module.exports = __webpack_public_path__ + "static/media/benefits4.ae8141f1.png";